import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CarDetailsRevamp from "./component";
import { fetchCarDetails, updateCarDetailsSSRStatus, setGsGalleryData, fetchSimilarCars, updateLoginFetchCarDetailCompleted, setCurrentDeliveryTimeline } from "../car-details/actions";
import { withRouter } from "react-router-dom";
import { reloadCarList } from "../car-listing/actions";
import {clearAllFilters, updateSelectedSuggestions, updateFilterOptionData} from "../filters/actions";
import withLogin from "../with-login";
import withWishlist from "../with-wishlist";
import { getDeliveryInfo } from "../delivery-info/actions";
import { fetchEgcPrice, getOrderDetail, updateOrder, getCheckoutSteps, getWarrantyPlans, getIsStraightThroughEligble, updateValidC2bOrder, getTradeInDetails } from "../checkout-info/actions";
import { fetchConfig } from "../home/actions";
import { getInhouseEligibility, getInhousePreApprovalLoanDetails, getInterestRateForPriceCalculator, setPreApprovalCoachMarkDisplay } from "../pre-approval-financing-flow/pre-approval-loan-wrapper/actions";
import { getTradeInToggleVisible } from "../trade-in-your-car-wrapper/actions";
import { getGuestToken, setLoginType } from "../../au.configuration/actions";
// import exitIntentPopup from "../exit-intent-popup";

const mapStateToProps = ({
    carDetails,
    location: {
        selectedCity
    },
    deliveryInfo: {
        appliedDeliveryPincode
    },
    user: {
        secureToken,
        hideSiteHeader,
        userGeoData,
        gaId
    },
    checkout: {
        order: { status: orderStatus, splitPaymentOpted, orderId, financeProvider, testDriveStatus}
    },
    user: {
        isLoggedIn,
        email,
        isUserZeroDpVariant
    },
    filters: {
        allFilters,
        appliedFilters,
        selectedSort,
        listingType
    },
    abExperiment: {
        showFullScreenGallery,
        showInHouseFinance,
        showPremiumFeatures,
        showUserDeliveryTimeline,
        showCdpGalleryVariant,
        cdpBiCta
        // showTestDriveV2
        // showTestDriveLocation
    },
    config: {
        saleConfig,
        testDriveConfig
    },
    preApprovalLoan: {
        inHouseFinanceEligibility,
        showPreApprovalCoachmark
    },
    tradeIn: {
        tradeInToggleSelected
    },
    supportWidget: {
        showEmailSupportModal
    }
}) => ({
    email,
    carDetails,
    selectedCity,
    appliedDeliveryPincode,
    secureToken,
    orderStatus,
    splitPaymentOpted,
    isLoggedIn,
    showFullScreenGallery,
    saleConfig,
    orderId,
    showInHouseFinance,
    inHouseFinanceEligibility,
    tradeInToggleSelected,
    showPreApprovalCoachmark,
    showPremiumFeatures,
    showUserDeliveryTimeline,
    financeProvider,
    allFilters,
    appliedFilters,
    selectedSort,
    listingType,
    isUserZeroDpVariant,
    showCdpGalleryVariant,
    hideSiteHeader,
    cdpBiCta,
    testDriveStatus,
    userGeoData,
    // showTestDriveLocation
    gaId,
    showEmailSupportModal,
    testDriveConfig
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fetchCarDetailsConnect: fetchCarDetails,
            updateCarDetailsSSRStatusConnect: updateCarDetailsSSRStatus,
            setGsGalleryDataConnect: setGsGalleryData,
            reloadCarListConnect: reloadCarList,
            clearAllFiltersConnect: clearAllFilters,
            fetchSimilarCarsConnect: fetchSimilarCars,
            getDeliveryInfoConnect: getDeliveryInfo,
            getOrderDetailConnect: getOrderDetail,
            fetchConfigConnect: fetchConfig,
            updateLoginFetchCarDetailCompletedConnect: updateLoginFetchCarDetailCompleted,
            fetchEgcPriceConnect: fetchEgcPrice,
            updateOrderConnect: updateOrder,
            getCheckoutStepsConnect: getCheckoutSteps,
            getInhouseEligibilityConnect: getInhouseEligibility,
            getTradeInToggleVisibleConnect: getTradeInToggleVisible,
            getWarrantyPlansConnect: getWarrantyPlans,
            setPreApprovalCoachMarkDisplayConnect: setPreApprovalCoachMarkDisplay,
            setDeliveryTimelineConnect: setCurrentDeliveryTimeline,
            getGustTokenInfoConnect: getGuestToken,
            updateSelectedSuggestionsConnect: updateSelectedSuggestions,
            updateFilterOptionDataConnect: updateFilterOptionData,
            setLoginTypeConnect: setLoginType,
            getInhousePreApprovalLoanDetailsConnect: getInhousePreApprovalLoanDetails,
            getIsStraightThroughEligbleConnect: getIsStraightThroughEligble,
            getInterestRateForPriceCalculatorConnect: getInterestRateForPriceCalculator,
            updateValidC2bOrderConnect: updateValidC2bOrder,
            getTradeInDetailsConnect: getTradeInDetails
        },
        dispatch
    );

export default withLogin(withWishlist(withRouter(connect(mapStateToProps, mapDispatchToProps)(CarDetailsRevamp))));
